module.exports = "<p>\r\n    Opening...\r\n</p>"